import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LoadingContent from './LoadingContent';

const TabPane = ({
  isLoading,
  children,
  className,
  nopadding,
  tabName,
  extraNavContent,
  linkTo,
  ...rest
}) => {
  const tabPaneClasses = cx('TabPane', 'tab-pane', className, {
    nopadding: nopadding || isLoading,
  });

  return (
    <div className={tabPaneClasses} {...rest}>
      {isLoading ? <LoadingContent /> : children}
    </div>
  );
};

TabPane.displayName = 'TabPane';

TabPane.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  nopadding: PropTypes.bool.isRequired,
  tabName: PropTypes.string.isRequired,
};

TabPane.defaultProps = {
  nopadding: false,
  isLoading: false,
  className: '',
};

export default TabPane;
